"use client";

import React from "react";
import useLazyPagination from "@/hooks/utils/useLazyPagination";
import { useSearchParams } from "next/navigation";
import BlogEmptyContent from "../blogEmptyContent";
import { ProjectApi } from "@/types";
import Box from "@sendsprint/ui-react/components/box";
import Button from "@sendsprint/ui-react/components/button";
import BlogCard from "../blogCard";

interface Props {
  blogs: ProjectApi.Blog.BlogData[];
}

const PostsContent = ({ blogs }: Props) => {
  const searchParams = useSearchParams();
  const searchValue = (searchParams.get("search") || "") as string;

  const filteredBlogs = blogs.filter((blog) => {
    const isSearchInCategory = !!blog.category.find((item) =>
      item.toLowerCase().includes(searchValue.toLowerCase()),
    );
    if (
      blog.title.toLowerCase().includes(searchValue.toLowerCase()) ||
      isSearchInCategory
    ) {
      return blog;
    }
  });

  const { handleClick, isLastPage, slicedPosts } = useLazyPagination(
    filteredBlogs,
    1,
    15,
  );

  const blogsLength = slicedPosts?.length;

  return (
    <Box className="ss:grid ss:grid-cols-1 ss:md:grid-cols-2 ss:lg:grid-cols-3 ss:gap-8">
      {slicedPosts &&
        slicedPosts.map((blog) => <BlogCard key={blog.id} {...blog} />)}
      {!blogsLength && <BlogEmptyContent />}
      {!isLastPage && (
        <Box className="ss:flex ss:md:col-span-2 ss:lg:col-span-3 ss:justify-center ss:mt-20">
          <Button
            onClick={handleClick}
            className="ss:px-20! ss:md:px-28!"
            label="Load More"
          />
        </Box>
      )}
    </Box>
  );
};

export default PostsContent;
